module.exports = __webpack_public_path__ + "static/img/code_1.4a4c5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/code_1.png
// module id = ZabE
// module chunks = 1